
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from '@uifabric/merge-styles';

import OpenButton from './OpenButton';
import SaveButton from './SaveButton';

const classNames = mergeStyleSets({
    root: {
        backgroundColor: '#e2e2e2',
        padding: '1em',
        display: 'flex',
        justifyContent: 'center',
    },

    container: {
        display: 'flex',
        width: '1024px',
        justifyContent: 'center'
    }
});

const PageFooter = ({
    onNewClick,
    onGetSaveData,
    onProcessOpenFile
}) => {

    const handleNewClick = () => {
        if (onNewClick) {
            onNewClick();
        }
    }

    return (
        <Stack horizontal className={classNames.root}>
            <Stack.Item className={classNames.container}>
                <OpenButton
                    onProcessOpenFile={onProcessOpenFile}
                    text="Načíst kalkulaci ze souboru"
                />
                <SaveButton
                    onGetSaveData={onGetSaveData}
                    text="Uložit kalkulaci do souboru"
                />
                <DefaultButton
                    onClick={handleNewClick}
                    styles={{
                        root: {
                            minWidth: '16em',
                            margin: '0em 0.2em'
                        }
                    }}
                    text="Nová kalkulace"
                />
            </Stack.Item>
        </Stack>
    )
}

export default PageFooter;
